module.exports = __webpack_public_path__ + "media/categories/6001-e84c7bcc.svg";